import React from "react";
import styled from "styled-components";

interface TagProps {
    children: React.ReactNode;
    variant?: "primary" | "secondary" | "success" | "warning" | "error" | "expired";
    size?: "small" | "medium" | "large";
    extraStyles?: React.CSSProperties;
}

export const Tag: React.FC<TagProps> = ({ children, variant = "primary", size = "small", extraStyles }) => {
    return (
        <Relative style={extraStyles}>
            <TagContainer variant={variant} size={size}>
                {children}
            </TagContainer>
        </Relative>
    );
};

const Relative = styled.div`
    position: relative;
`;

const TagContainer = styled.div<{ variant: string; size: string }>`
    display: inline-flex;
    padding: 3px 8px;
    align-items: flex-start;
    gap: 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.2;

    ${({ variant }) => {
        switch (variant) {
            // suggest nice color for payment pending
            case "primary":
                return `
                    background-color: #FEF3C7;
                    color: #92400E;
                `;
            case "secondary":
                return `
                    background-color: #E5E7EB;
                    color: #374151;
                `;
            case "success":
                return `
                    background-color: #C8F9E5;
                    color: #0C7266;
                `;
            case "warning":
                return `
                    background-color: #FFF0CD;
                    color: #D07D00;
                `;
            case "error":
                return `
                    background-color: #FEE2E2;
                    color: #991B1B;
                `;
            case "expired":
                return `
                    background-color: #FFECEF;
                    color: #FA3C5A;
                `;
            default:
                return `
                    background-color: #F59E0B;
                    color: #92400E;
                `;
        }
    }}

    ${({ size }) => {
        switch (size) {
            case "small":
                return `
                    padding: 3px 8px;
                    font-size: 12px;
                `;
            case "medium":
                return `
                    padding: 4px 12px;
                    font-size: 14px;
                `;
            case "large":
                return `
                    padding: 6px 16px;
                    font-size: 16px;
                `;
            default:
                return `
                    padding: 3px 8px;
                    font-size: 12px;
                `;
        }
    }}
`;
